export default __webpack_public_path__ + "static/international-yards-desktop-9e950b74e004b58812fa188881da9aff.svg";